import React, {useEffect, useState} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import axios from "axios";
import {ISurvey} from "../../../data/interfaces/ISurvey";
import {IQuestion} from "../../../data/interfaces/IQuestion";
import {IQuestionGroup} from "../../../data/interfaces/IQuestionGroup";
import {ISurveyUserData} from "../../../data/interfaces/ISurveyUserData";
import {SurveyApi} from "../../../data/api/SurveyApi";
import {SurveyService} from "../../../data/services/SurveyService";
import {GroupComponent} from "../../survey/groupComponent";
import "./style.scss";


export function ResponseItem() {

    const {id} = useParams();

    const surveyApi = SurveyApi();
    const surveyService = SurveyService();

    const [survey, setSurvey] = useState<ISurvey | undefined>(undefined);

    const [surveyCompleted, setSurveyCompleted] = useState<boolean>(false);

    const [data, setData] = useState<ISurveyUserData | undefined>(undefined)


    const loadSurvey = async (id?: string) => {
        if(id != null) {
            try {
                const response = await surveyApi.getSurvey2(id, axios.CancelToken.source().token);
                if (response.data !== null) {
                    setSurvey(response.data);
                }

            } catch (ex: any) {
                setData(undefined);
                setSurvey(undefined);
            }
        }
        else {
            setData(undefined);
            setSurvey(undefined);
        }
    }

    const updateSurvey = (question: IQuestion) => {
        setSurvey(prev => {
            if(prev === undefined) {
                return prev;
            }

            const mapGroup: (g: IQuestionGroup) => IQuestionGroup = (g: IQuestionGroup) => {
                return {
                    ...g,
                    questions: g.questions.map(x => mapQuestion(x)),
                    groups: g.groups.map(x => mapGroup(x))
                } as IQuestionGroup;
            }

            const mapQuestion: (q: IQuestion) => IQuestion = (q: IQuestion) => {
                if(q.id === question.id) {
                    return question;
                }
                return q;
            }

            return {
                ...prev,
                questions: prev.groups.map(g => mapGroup(g))
            }
        })
    }


    const getQuestion = () => {
        const getGroupQuestions: (group: IQuestionGroup) => IQuestion[] = (group: IQuestionGroup) => {
            return [
                ...group.questions,
                ...group.groups.flatMap(g => getGroupQuestions(g))
            ] ?? [];
        }
        return survey?.groups.flatMap(g => {
            return [
                ...g.questions,
                ...g.groups.flatMap(g => getGroupQuestions(g))
            ];
        }) ?? []
    }

    const questions = getQuestion();


    useEffect(() => { loadSurvey(id); }, [id]);


    return (
        <>

            {
                (survey !== undefined && surveyCompleted) && (
                    <div className={("survey-success-message")}>
                        Ваш отзыв обработан. Благодарим за уделенное время!
                    </div>
                )
            }

            {
                (survey !== undefined && !surveyCompleted) && (
                    <div className="survey-form-wrapper">
                        <div className="survey-form-container">

                            <div className="survey-form">

                                <div className="survey-form-title">{survey?.title}</div>

                                <div className="survey-form-description">
                                    {survey?.description}
                                </div>

                                {
                                    survey.groups.map((group, groupIndex) => {
                                        return (
                                            <GroupComponent
                                                key={groupIndex}
                                                group={group}
                                                onChange={(n) => {}}
                                            />
                                        );
                                    })
                                }

                            </div>

                        </div>

                    </div>
                )
            }
        </>
    );
}